import React, { useContext, useEffect, useReducer } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { DashBoarRouter } from "./DashBoarRouter"
import { PublicRoute } from './PublicRoute';
import { PrivateRouter } from "./PrivateRouter";
import { LoginContext } from '../context/LoginContext';
import { Auth } from '../pages/Auth';

export const AppRouter = () => {

    const { user, setUser } = useContext(LoginContext);
    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("user")) || null);
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/auth"
                    element={
                        <PublicRoute user={user}>
                            <Auth />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/*"
                    element={
                        <PrivateRouter user={user}>
                            <DashBoarRouter />
                        </PrivateRouter>
                    }
                />

            </Routes>
        </BrowserRouter>
    )
}
